import { device } from 'app/ui-components/breakpoints';
import { playGrey15, regularBlack, regularWhite, svgIconNewWindow } from 'app/ui-components/design-tokens';
import { playFocus } from 'app/ui-components/utils.styles';
import styled from 'styled-components';

export const StyledCookieMessage = styled.div`
    @media ${device.GteSmall} {
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 300;
    }

    .svt-cookie_custom-style.svt-cookie_container {
        background-color: ${playGrey15};

        @media ${device.GteSmall} {
            padding: 25px 20px 25px 20px;
        }
        @media ${device.GteXLarge} {
            padding: 25px 0 25px 0;
        }
    }

    .svt-cookie_custom-style {
        & .svt-cookie_holder {
            display: flex;
            flex-direction: column;
            max-width: none;

            @media ${device.GteSmall} {
                flex-direction: row;
            }

            @media ${device.GteXLarge} {
                margin-left: 75px;
                margin-right: 75px;
            }

            @media ${device.FullScreen} {
                max-width: 1280px;
                margin: auto;
            }
        }

        & .svt-cookie_holder__form {
            float: none;
            width: auto;
            align-self: center;
        }

        & .svt-cookie_holder__text {
            color: ${regularWhite};

            & .svt-cookie_holder__link {
                color: ${regularWhite};
                ${playFocus()}
            }
            & .svt-cookie_holder__link-icon {
                background-image: url('data:image/svg+xml;base64,${svgIconNewWindow}') !important;
                margin: 0 5px;
            }
        }

        & .svt-cookie_holder__button {
            font-size: 14px;
            background-color: ${regularBlack};
            text-transform: uppercase;
            ${playFocus()}

            @media ${device.GteSmall} {
                margin-left: 40px;
            }

            &:hover,
            &:focus {
                background-color: ${regularWhite};
                color: ${regularBlack};
                border: 1px solid ${regularBlack};
            }
        }
    }
`;
